import { css, useTheme } from '@emotion/react'
import React, { useState } from 'react'
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai'

function Accordion({ title, content }) {
    const [isActive, setIsActive] = useState(false)
    const theme = useTheme()
    const style = css`
        .accordion-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.3rem 0.5rem;
            background-color: ${theme.colors?.accordion?.headBackground};
            border-radius: ${theme.borderRadius?.default};
            color: ${theme.colors?.accordion?.titleColor};
        }
        .accordion-open-ind {
            font-size: 1.5em;
        }
        .accordion-content {
            padding: 0.5rem;
            color: ${theme.colors?.accordion?.color};
        }
    `
    return (
        <div className="accordion" css={style}>
            <div className="accordion-item">
                <div
                    className="accordion-title outline outline-offset-4 outline-1"
                    onClick={() => setIsActive(!isActive)}
                >
                    <div className="title">{title}</div>
                    <div className="accordion-open-ind">
                        {isActive ? (
                            <AiOutlineMinusCircle />
                        ) : (
                            <AiOutlinePlusCircle />
                        )}
                    </div>
                </div>
                {isActive && <div className="accordion-content">{content}</div>}
            </div>
        </div>
    )
}

export default Accordion
